<template>
  <div class="category-description">
    <transition mode="out-in">
      <p
        class="category-description-short"
        v-if="!showMore && sentences.length > 2"
        v-html="descriptionShort = this.description.split('</p>')[0]"
      />
      <p
        class="category-description-long"
        v-if="showMore || sentences.length <= 2"
        v-html="description"
      />
    </transition>
    <p
      class="btn btn--small btn--dark-blue button-outline"
      v-if="!showMore && sentences.length > 2"
      @click="showMore = true"
    >
      Rozwiń opis
    </p>
    <p
      class="btn btn--small btn--dark-blue button-outline"
      v-if="showMore && sentences.length > 2"
      @click="showMore = false"
    >
      Zwiń opis
    </p>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showMore: false,
      sentences: [],
      descriptionWithoutTags: "",
    };
  },
  mounted() {
    this.stripTags();
    this.checkString();
  },
  methods: {
    checkString() {
      this.sentences = this.descriptionWithoutTags
        .replace(/([.?!])\s*(?=[A-Z])/g, "$1|")
        .split("|");
    },
    stripTags() {
      let regex = /(<([^>]+)>)/gi;
      this.descriptionWithoutTags = this.description.replace(regex, "");
    },
    getSentences(count) {
      let resultString = "";
      let i = 0;
      if (this.sentences.length > 2) {
        this.sentences.forEach((sentence) => {
          if (i < count) {
            if (this.descriptionShort !== "") {
              this.descriptionShort += " ";
            }
            this.descriptionShort += sentence;
          }
          i++;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~theme/css/variables/colors";
@import "~theme/css/helpers/functions/color";
$color-mid-grey: color(mid-grey);

.category-description {
  &-short {
    color: $color-mid-grey;
  }
  &-long {
    color: $color-mid-grey;
  }
  .btn {
    cursor: pointer;
  }
}

.button-outline {
  border: 2px solid;
  height: 40px;
  width: 220px;
  border-radius: 24px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
</style>
